import { ItemTypeConsts, ItemTypeDisplayNames } from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';

const ReportsDownloadPanel = () => import('client/Reports/ReportsDownloadPanel.vue');
const ReportsMainPanel = () => import('client/Reports/ReportsMainPanel.vue');

export default (enabledFlags) => [
  {
    path: '/reports/downloads',
    meta: {
      title: ItemTypeDisplayNames[ItemTypeConsts.reports],
    },
    components: {
      mainPanel: ReportsDownloadPanel,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.synthesizedReports];
      const routeOrRedirect = showRoute ? true : { path: '/home' };
      next(routeOrRedirect);
    },
  },
  {
    path: '/reports',
    meta: {
      title: ItemTypeDisplayNames[ItemTypeConsts.reports],
    },
    components: {
      mainPanel: ReportsMainPanel,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.synthesizedReports];
      const routeOrRedirect = showRoute ? true : { path: '/home' };
      next(routeOrRedirect);
    },
  },
  {
    path: '/reports*',
    redirect: '/reports',
  },
];
